module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"facility":"Facility","mrtRoute":"MRT Route","shoppingMall":"Shopping Mall","btsRoute":"BTS Route"},"th":{"facility":"สิ่งอำนวยความสะดวก","mrtRoute":"เส้นทาง MRT","shoppingMall":"ห้างสรรพสินค้า","btsRoute":"เส้นทาง BTS"}}')
  delete Component.options._Ctor
}
